import styled from 'styled-components';

export const StyledTags = styled.div`
  display: flex;
  grid-gap: 4px;
  grid-template-columns: ${(p) => p.inList && 'auto auto'};
  justify-content: ${(p) => p.inList && 'start'};
`;
